export enum TaskStatusType {
  CourierDeparted = "CourierDeparted",
  Completed = "Completed",
  CourierHeading = "CourierHeading",
  Assigned = "Assigned",
  CourierArrived = "CourierArrived",
  Canceled = "Canceled",
  ContactNotAvailable = "ContactNotAvailable",
  Unassigned = "Unassigned",
  CourierApproaching = "CourierApproaching",
  ManualHandled = "ManualHandled"
}
